import { render, staticRenderFns } from "./floor1Dialog.vue?vue&type=template&id=63fc2e84&scoped=true"
import script from "./floor1Dialog.vue?vue&type=script&lang=js"
export * from "./floor1Dialog.vue?vue&type=script&lang=js"
import style0 from "./floor1Dialog.vue?vue&type=style&index=0&id=63fc2e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc2e84",
  null
  
)

export default component.exports